import styled from 'styled-components'
import { fontType } from 'shared/styles/functions'

export const ModalReportErrorWrapper = styled.div``
export const Item = styled.p`
	${fontType(0)}
`
